import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FormService } from 'src/app/_core/services/form.service';
import { email, password } from 'src/app/_core/utils/helpers/validators';

export type LoginForm = {
  email: FormControl<string>;
  password: FormControl<string>;
};

export type LoginDto = {
  email: string;
  password: string;
};

@Injectable({ providedIn: 'root' })
export class LoginFormService extends FormService<LoginForm> {
  constructor() {
    super();

    this.form = this.fb.group<LoginForm>({
      email: this.fb.control('', [
        email,
        Validators.required,
        Validators.maxLength(100),
      ]),
      password: this.fb.control('', [
        password,
        Validators.required,
        Validators.minLength(8),
      ]),
    });
  }
}
